const rmsApiProxy = require('../api/rmsApiProxy');
const configurationManager = require('../config/configurationManager');
const currentOrgNodeSelectors = require('../../utils/state/stateSelectors/currentOrgNodeSelectors');

export function getCloudinaryUsersCloudName(): string
{
    return configurationManager.getConfig().cdnUsersCloudName;
}

export function isImgixAsset(assetUrl: unknown): boolean
{
    if (assetUrl && typeof assetUrl === "string") {
        return assetUrl.includes('imgix.net');
    }
    return false;
}

export async function uploadImageFile(imgFile: File, imageCategory: string): Promise<string>
{
    if (imgFile instanceof File) {
        const form = new FormData();
        form.append('payload', imgFile);

        const resourceEndpoint = `imageUpload/${imageCategory}`;
        let requestUrl: string;

        if(currentOrgNodeSelectors.isCurrentSystemSelected())
        {
            requestUrl = `core/system/${resourceEndpoint}`;
        }
        else
        {
            requestUrl = `${rmsApiProxy.getFranchisorOrgContextUrl()}/${resourceEndpoint}`;
        }

        const uploadedImageUrl = await rmsApiProxy.postForm(requestUrl, form);
        return uploadedImageUrl;
    }

    throw new Error('argument must be an instance of File');
}

export async function uploadImageLink(imgLink: string, imageCategory: string): Promise<string>
{
    if (typeof imgLink === "string") {
        const resourceEndpoint = `imageUpload/${imageCategory}`;
        let requestUrl: string;

        if(currentOrgNodeSelectors.isCurrentSystemSelected())
        {
            requestUrl = `core/system/${resourceEndpoint}`;
        }
        else
        {
            requestUrl = `${rmsApiProxy.getFranchisorOrgContextUrl()}/${resourceEndpoint}`;
        }

        const uploadedImageUrl = await rmsApiProxy.post(requestUrl, {url: imgLink});
        return uploadedImageUrl;
    }

    throw new Error('argument must be of type string');
}

export function getImgixBaseUrl(): string
{
    return configurationManager.getConfig().rmsImgixCDNServerUrl;
}

export function getBackOfficeImgixBaseUrl(): string
{
    return `${getImgixBaseUrl()}/app/back.office`;
}
